import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../core/reducers';
import { LayoutUtilsService } from '../../../../core/_base/crud';
import { AuthService, UserService } from '../../../../core/auth/_services';
import { NotificationService } from '../../../../core/lists';
import { CommunicationsService } from '../../../../core/timeline/_services';
import { UserLoaded } from '../../../../core/auth';
import { stop } from '../../../../core/_base/layout/directives/chat-count-twixor.directive';

@Component({
  selector: 'kt-manage-notification-sound',
  templateUrl: './manage-notification-sound.component.html',
  styleUrls: ['./manage-notification-sound.component.scss'],
})
export class ManageNotificationSoundComponent implements OnInit {
  notificationSoundForm: FormGroup;
  private hasFormErrors: boolean;
  firstAttachmentName;
  firstFile;
  @ViewChild('firstSound') firstSound: ElementRef;
  firstSoundSrc: string | ArrayBuffer;
  firstSoundChangedVar = false;
  secondAttachmentName;
  secondFile;
  @ViewChild('secondSound') secondSound: ElementRef;
  secondSoundSrc: string | ArrayBuffer;
  secondSoundChangedVar = false;
  private firstAttachmentDetails = { url: '', uuid: '' };
  private secondAttachmentDetails = { url: '', uuid: '' };

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ManageNotificationSoundComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private store: Store<AppState>,
    private layoutUtilsService: LayoutUtilsService,
    private userService: UserService,
    private notificationService: NotificationService,
    private communicationsService: CommunicationsService,
    private auth: AuthService,
  ) {}

  ngOnInit() {
    this.createNotificationSoundForm();
  }

  toDataURL(url, callback) {
    const xhr = new XMLHttpRequest();
    xhr.onload = () => {
      const reader = new FileReader();
      reader.onloadend = () => {
        callback(reader.result);
      };
      reader.readAsDataURL(xhr.response);
    };
    if (url) {
      xhr.open('GET', url);
      xhr.responseType = 'blob';
      xhr.send();
    }
  }

  createNotificationSoundForm() {
    this.notificationSoundForm = this.fb.group({
      repetitions: [
        this.data.notification?.repeated_sound_times
          ? this.data.notification.repeated_sound_times
          : 1,
      ],
      seconds: [this.data.notification?.seconds ? this.data.notification.seconds : 30],
      mute: [!this.data.notification?.mute],
    });
    // Get exist sounds and preview
    const notification_sound_url = this.data.notification?.notification_sound_url
      ? this.data.notification.notification_sound_url
      : './assets/sounds/newNotification.mp3';
    this.toDataURL(notification_sound_url, (res) => {
      this.firstSoundSrc = res;
    });
    const repeated_sound_url = this.data.notification?.repeated_sound_url
      ? this.data.notification?.repeated_sound_url
      : './assets/sounds/Notification.mp3';
    this.toDataURL(repeated_sound_url, (res) => {
      this.secondSoundSrc = res;
    });
    // Get uuids for request body
    if (this.data.notification?.notification_sound) {
      this.firstAttachmentDetails.uuid = this.data.notification?.notification_sound;
    }
    if (this.data.notification?.repeated_sound) {
      this.secondAttachmentDetails.uuid = this.data.notification?.repeated_sound;
    }
  }

  save() {
    this.updateSettings();
    this.auth.getUserByToken().subscribe((user) => {
      this.store.dispatch(new UserLoaded({ user }));
      this.cdr.detectChanges();
    });
    this.dialogRef.close();
  }

  updateSettings() {
    const updateBody = {
      mute: !this.notificationSoundForm.controls.mute.value,
      seconds: this.notificationSoundForm.controls.seconds.value,
      notification_sound: this.firstAttachmentDetails.uuid,
      repeated_sound: this.secondAttachmentDetails.uuid,
      repeated_sound_times: this.notificationSoundForm.controls.repetitions.value,
    };
    this.notificationService.updateNotificationSettings(updateBody).subscribe(() => {
      stop();
    });
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.notificationSoundForm.controls[controlName];
    if (!control) {
      return false;
    }
    return control.hasError(validationType) && (control.dirty || control.touched);
  }

  returnAttachmentNameTooltip(a) {
    if ((this.data.mode === 'update' || this.data.readonly) && !this.data.nonDB)
      return this.getAttachmentName(a);
    if (this.data.mode === 'create' || this.data.nonDB) return a;
    return '';
  }

  getAttachmentName(attachment) {
    return attachment;
  }

  firstSoundChanged(event: any) {
    this.firstAttachmentName = event.target.files[0].name;
    this.firstFile = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onloadend = () => {
      this.firstSoundSrc = reader.result;
      this.firstSoundChangedVar = true;
      this.cdr.detectChanges();
    };
    this.notificationService
      .getPreSignedURL(this.firstAttachmentName)
      .subscribe((attachmentDetails) => {
        this.firstAttachmentDetails = attachmentDetails;
        this.communicationsService
          .uploadProfilePic(this.firstAttachmentDetails.url, this.firstFile)
          .subscribe();
      });
  }

  secondSoundChanged(event: any) {
    this.secondAttachmentName = event.target.files[0].name;
    this.secondFile = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onloadend = () => {
      this.secondSoundSrc = reader.result;
      this.secondSoundChangedVar = true;
      this.cdr.detectChanges();
    };
    this.notificationService
      .getPreSignedURL(this.secondAttachmentName)
      .subscribe((attachmentDetails) => {
        this.secondAttachmentDetails = attachmentDetails;
        this.communicationsService
          .uploadProfilePic(this.secondAttachmentDetails.url, this.secondFile)
          .subscribe();
      });
  }
}
